import { render } from "./px-navigation-tab-item.vue?vue&type=template&id=75835a9e&scoped=true&ts=true"
import script from "./px-navigation-tab-item.vue?vue&type=script&lang=ts"
export * from "./px-navigation-tab-item.vue?vue&type=script&lang=ts"

import "./px-navigation-tab-item.vue?vue&type=style&index=0&id=75835a9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75835a9e"]])

export default __exports__